// extracted by mini-css-extract-plugin
export default {"button":"TopicsList_button__k4S9p"};